import { Grid } from '@ui-propulsion/react-components';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import styles from './ratesTable.module.scss';
import RatesTableList from './rateTableList/ratesTableList';

export default function RatesTable({
  title = '',
  description = '',
  cta = '',
  tableData = [],
  disclaimer = '',
  theme = 'grey',
}) {
  return (
    <section className={`${styles[theme]}`}>
      <Grid container>
        <Grid item container xs={12} justifyContent="center">
          {title && <h2 className={styles.title}>{title}</h2>}
          {description && (
            <div className={styles.description}>{parse(`${description}`)}</div>
          )}
        </Grid>
        {tableData && <RatesTableList data={tableData} cta={cta} />}
        {disclaimer && (
          <Grid item container xs={12} justifyContent="center">
            <div className={styles.disclaimer}>{parse(`${disclaimer}`)}</div>
          </Grid>
        )}
      </Grid>
    </section>
  );
}

RatesTable.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  cta: PropTypes.any,
  tableData: PropTypes.array,
  disclaimer: PropTypes.string,
  theme: PropTypes.string,
};
